<template>
    <div>
        <b-modal
            v-model="showModalLocal"
            :title="'Выбор или добавление заказчика'"
            class="modal-primary"
            size="xl"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >
            <form data-vv-scope="customerform" name="customerform" @submit.prevent >
                <div class="row">
                    <div class="col col-lg-4">
                        <b-form-group
                            :label="phone_label"
                            :state="validateScopedState('customerform', 'customer_tel')"
                            :invalid-feedback="veeErrors.first('customerform.customer_tel')"
                            description="Номер телефона является основным способом идентификации заказчика в системе. Неуказание номера телефона является страшным грехом, за которым следуют ужасные кары.
    Вы можете указывать номер в любом удобном для вас формате, но помните, что в расчет принимаются только последние 10 цифр"
                        >
                            <b-form-input
                                type="text" id="customer_tel"
                                v-model="customer_create.tel"
                                v-validate="phone_rules"
                                name="customer_tel"
                                data-vv-as="'Телефон'"
                                :state="validateScopedState('customerform', 'customer_tel')"
                                aria-describedby="customer_tel_feedback"
                                @input="onInputPhone"
                                @change="onChangePhone"
                            ></b-form-input>
                        </b-form-group>
                    </div>


                    <div class="col col-lg-4" v-if="customer_by_tel">
                        <b-form-group
                            label="Найден заказчик по номеру телефона"
                            :description="customer_by_tel.description"
                            :invalid-feedback="customer_by_tel.invalid"
                            :state="customer_by_tel.state"
                        >
                            <b-form-input  v-model="customer_by_tel.fullname" readonly :state="customer_by_tel.state"></b-form-input>
                        </b-form-group>
                    </div>

                    <div class="col col-lg-4" v-if="customer_by_tel">
                        <b-form-group label="Выбрать этого заказчика">
                            <button class="btn btn-success" @click="selectCustomer(customer_by_tel.id)">выбрать</button>
                        </b-form-group>
                    </div>


                </div>

                <div class="row">
                    <div class="col col-lg-4">
                        <b-form-group
                            :label="email_label"
                            :state="validateScopedState('customerform', 'customer_email')"
                            :invalid-feedback="veeErrors.first('customerform.customer_email')"
                            description="E-mail является альтернативным способом идентификации. Если не указан номер телефна e-mail обязателен"
                        >
                            <b-form-input
                                type="text" id="customer_email"
                                v-model="customer_create.email"
                                v-validate="email_rules"
                                name="customer_email"
                                data-vv-as="'E-mail'"
                                :state="validateScopedState('customerform', 'customer_email')"
                                aria-describedby="customer_email_feedback"
                                @input="onInputEmail"
                                @change="onChangeEmail"
                            ></b-form-input>
                        </b-form-group>
                    </div>

                    <div class="col col-lg-4" v-if="customer_by_email">
                        <b-form-group
                            label="Найден заказчик по e-mail"
                            :description="customer_by_email.description"
                            :invalid-feedback="customer_by_email.invalid"
                            :state="customer_by_email.state"
                        >
                            <b-form-input v-model="customer_by_email.fullname"  readonly  :state="customer_by_email.state"></b-form-input>
                        </b-form-group>
                    </div>

                    <div class="col col-lg-4" v-if="customer_by_email">
                        <b-form-group label="Выбрать этого заказчика">
                            <button class="btn btn-success" @click="selectCustomer(customer_by_email.id)">выбрать</button>
                        </b-form-group>
                    </div>

                </div>


                <div class="row" v-if="can_fill_customer_name">
                    <div class="col-12 col-lg-4">
                        <b-form-group
                            label="* Фамилия"
                            :state="validateScopedState('customerform', 'customer_surname')"
                            :invalid-feedback="veeErrors.first('customerform.customer_surname')">
                            <b-form-input
                                type="text"
                                v-model="customer_create.surname"
                                v-validate="{max:30,name:true,required:true}"
                                id="customer_surname"
                                name="customer_surname"
                                data-vv-as="'Фамилия'"
                                :state="validateScopedState('customerform', 'customer_surname')"
                                aria-describedby="customer_surname_feedback"
                                required
                                @input="onInputSurname"
                                @change="onChangeSurname"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-lg-4">
                        <b-form-group
                            label="* Имя"
                            :state="validateScopedState('customerform', 'customer_name')"
                            :invalid-feedback="veeErrors.first('customerform.customer_name')"
                            required
                        >
                            <b-form-input
                                type="text"
                                v-model="customer_create.name"
                                v-validate="{max:30,name:true,required:true}"
                                id="customer_name"
                                name="customer_name"
                                data-vv-as="'Имя'"
                                :state="validateScopedState('customerform', 'customer_name')"
                                aria-describedby="customer_name_feedback"
                                required
                                @input="onInputName"
                                @change="onChangeName"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-lg-4">
                        <b-form-group
                            label="Отчество"
                            :state="validateScopedState('customerform', 'customer_patro')"
                            :invalid-feedback="veeErrors.first('customerform.customer_patro')">
                            <b-form-input
                                type="text"
                                v-model="customer_create.patro"
                                v-validate="{max:30,name:true, }"
                                id="customer_patro"
                                name="customer_patro"
                                data-vv-as="'Отчество'"
                                :state="validateScopedState('customerform', 'customer_patro')"
                                aria-describedby="customer_patro_feedback"
                                @input="onInputPatro"
                                @change="onChangePatro"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>

                <template  v-if="customer_by_name2 && customer_by_name2.length">
                    <div class="alert alert-warning">
                        В базе данных найдено {{ customer_by_name2.length }} тезок. Рекомендуем тщательно проверить что это разные люди.
                        Потому что нет страшнее проступка чем наплодить дубликатов в базе.
                    </div>

                    <div class="row" v-for="c in customer_by_name2">
                        <div class="col col-lg-4">
                            <b-form-group :description="customerDescription(c)">
                                <b-form-input  :value="customerFullname(c)"  readonly >
                                </b-form-input>
                            </b-form-group>
                        </div>

                        <div class="col col-lg-4">
                            <b-form-group>
                                <button class="btn btn-success" @click="selectCustomer(c.id)">выбрать</button>
                            </b-form-group>
                        </div>
                    </div>
                </template>

<!--                <template  v-if="!customer_by_name3 && customer_by_name2 && customer_by_name2.length">-->
<!--                    <div class="alert alert-warning">-->
<!--                        В базе данных найдено {{ customer_by_name2.length }} тезок. Рекомендуем указать отчество для контроля того что вы не плодите дубликатов.-->
<!--                    </div>-->
<!--                </template>-->

                <div class="row" v-if="can_fill_customer_name">
                    <div class="col-12 col-lg-4">
                        <b-form-group
                            label="ИНН"
                            :state="validateScopedState('customerform', 'customer_org_inn')"
                            :invalid-feedback="veeErrors.first('customerform.customer_org_inn')">
                            <b-form-input
                                type="text"
                                v-model="customer_create.org_inn"
                                v-validate="{inn:true,}"
                                id="customer_org_inn"
                                name="customer_org_inn"
                                data-vv-as="'ИНН'"
                                :state="validateScopedState('customerform', 'customer_org_inn')"
                                aria-describedby="customer_surname_feedback"
                                required
                                @input="onInputInn"
                                @change="onChangeInn"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>

                <template  v-if="customer_by_inn && customer_by_inn.length">
                    <div class="alert alert-warning">
                        В базе данных найдено {{ customer_by_inn.length }} заказчиков с таким же ИНН.
                    </div>

                    <div class="row" v-for="c in customer_by_inn">
                        <div class="col col-lg-4">
                            <b-form-group :description="customerDescription(c)">
                                <b-form-input  :value="customerFullname(c)"  readonly >
                                </b-form-input>
                            </b-form-group>
                        </div>

                        <div class="col col-lg-4">
                            <b-form-group>
                                <button class="btn btn-success" @click="selectCustomer(c.id)">выбрать</button>
                            </b-form-group>
                        </div>
                    </div>
                </template>

                <div class="row" v-if="can_fill_customer_name">
                    <div class="col col-lg-4">
                        <b-form-group
                            label="Пароль"
                            :state="validateScopedState('customerform', 'customer_password')"
                            :invalid-feedback="veeErrors.first('customerform.customer_password')"
                            description="Пароль для входа пользователя на сайте агентства. Не трогайте, если не планируете менять "
                        >
                            <b-form-input
                                type="text" id="customer_password"
                                v-model="customer_create.password"
                                v-validate="{max:20,}"
                                name="customer_password"
                                data-vv-as="'Пароль'"
                                :state="validateScopedState('customerform', 'customer_password')"
                                aria-describedby="customer_password_feedback"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>
            </form>


            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button  variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
                <b-button variant="success" @click="ok()" v-if="can_create_customer">
                    Создать заказчика
                </b-button>
            </template>


        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions';
    import { functions_customers } from '@/functions_customers.js';

    export default {
        name: 'CreateCustomerDialog',
        mixins: [functions, functions_customers],
        data: function () {
            return {
                customer_create: {
                    surname:'',
                    name:'',
                    patro:'',
                    password:'',
                    tel:'',
                    email:'',
                    org_inn:'',
                },
                phone_label:'* Телефон',
                email_label:'* E-mail',
                phone_rules:{max:20,anyphone:true,required:true},
                email_rules:{max:60,email:true,required:true},

                customer_by_tel:null,
                customer_by_email:null,
                customer_by_name2:null,
                customer_by_name3:null,
                customer_by_inn:null,
                customer_not_found: false,
                thresholdTimeout:null,
                needLookupCustomer: false
            };
        },
        model: {
            prop: "show_customer",
            event: "hide"
        },
        props: {
            show_customer: [Number, Boolean],
            voucherx: [Object]
        },
        methods: {
            selectCustomer: function(id) {
                this.voucherx.customer_id = id;
                this.$emit("hide", false);
                this.$emit("changed", false);
            },
            reloadCustomer: function() {
            },
            customerAfterLoad: function() {
            },
            onCancel: function() {

            },
            onApply: function () {
            },
            onSave: function () {
            },

            handleCancel: function () {
                this.$emit("hide", false);
            },
            handleOk: function () {
                this.createCustomer(this.customer_create, this.customerCreated);
            },
            customerCreated: function(param, id) {
                console.log('customerCreated id', id);
                this.voucherx.customer_id = id;
                console.log('customerCreated this.voucherx.customer_id', this.voucherx.customer_id);
                this.onApply();
                this.$emit("changed", false);
                this.$emit("hide", false);
            },
            handleSubmit: function () {
                this.$emit("hide", false);
            },
            onInputPhone:function () {
                if (this.customer_create.tel) {
                    this.email_label='E-mail';
                    this.email_rules={max:60,email:true};
                }
                else {
                    this.email_label='* E-mail';
                    this.email_rules={max:60,email:true,required:true};
                }
                this.needLookupCustomer = true;
                this.threshold(this.revalidate);
            },
            onInputEmail:function () {
                if (this.customer_create.email) {
                    this.phone_label='Телефон';
                    this.phone_rules={max:20,anyphone:true};
                }
                else {
                    this.phone_label='* Телефон';
                    this.phone_rules={max:20,anyphone:true,required:true};
                }
                this.needLookupCustomer = true;
                this.threshold(this.revalidate);
            },
            onChangePhone:function () {
                this.doLookupCustomer();
            },
            onChangeEmail:function () {
                this.doLookupCustomer();
            },
            onInputPatro:function () {
                if (this.customer_create.name.trim() && this.customer_create.surname.trim()) {
                    this.needLookupCustomer = true;
                }
                this.threshold(this.revalidate);
            },
            onChangePatro:function () {
                if (this.customer_create.name.trim() && this.customer_create.surname.trim()) {
                    this.doLookupCustomer();
                }
            },
            onInputSurname:function () {
                if (this.customer_create.name.trim() && this.customer_create.surname.trim()) {
                    this.needLookupCustomer = true;
                }
                this.threshold(this.revalidate);
            },
            onChangeSurname:function () {
                if (this.customer_create.name.trim() && this.customer_create.surname.trim()) {
                    this.doLookupCustomer();
                }
            },
            onInputName:function () {
                if (this.customer_create.name.trim() && this.customer_create.surname.trim()) {
                    this.needLookupCustomer = true;
                }
                this.threshold(this.revalidate);
            },
            onChangeName:function () {
                if (this.customer_create.name.trim() && this.customer_create.surname.trim()) {
                    this.doLookupCustomer();
                }
            },
            onInputInn:function () {
                if (this.customer_create.org_inn.trim()) {
                    this.needLookupCustomer = true;
                }
                this.threshold(this.revalidate);
            },
            onChangeInn:function () {
                if (this.customer_create.name.trim() && this.customer_create.surname.trim()) {
                    this.doLookupCustomer();
                }
            },

            doLookupCustomer:function () {
                this.needLookupCustomer = false;
                this.lookupCustomer(this.customer_create, function(self, lookup_result){
                    self.customer_by_tel = null;
                    self.customer_by_email = null;
                    self.customer_by_name2 = null;
                    self.customer_by_name3 = null;
                    self.customer_by_inn = null;
                    console.log(lookup_result);
                    self.customer_by_tel = lookup_result.c_tel;
                    self.customer_by_email = lookup_result.c_email;
                    self.customer_by_name2 = lookup_result.c_name2;
                    self.customer_by_name3 = lookup_result.c_name3;
                    self.customer_by_inn = lookup_result.c_inn;
                    self.customer_not_found = !lookup_result.c_tel && !lookup_result.c_email

                    if (self.customer_by_tel) {
                        self.customer_by_tel.fullname = self.customerFullname(self.customer_by_tel);
                        self.customer_by_tel.description = self.customerDescription(self.customer_by_tel);
                        if (self.customer_by_email) {
                            if (self.customer_by_tel.id!==self.customer_by_email.id) {
                                self.customer_by_tel.invalid = "не совпадает с заказчиком найденным по номеру телефона";
                                self.customer_by_tel.state='invalid';
                            }
                            else {
                                self.customer_by_tel.description += ", совпадает с заказчиком найденным по номеру телефона";
                                self.customer_by_tel.state='valid';
                            }
                        }
                    }
                    if (self.customer_by_email) {
                        self.customer_by_email.fullname = self.customerFullname(self.customer_by_email);
                        self.customer_by_email.description = self.customerDescription(self.customer_by_email);
                        if (self.customer_by_tel) {
                            if (self.customer_by_tel.id!==self.customer_by_email.id) {
                                self.customer_by_email.invalid = "не совпадает с заказчиком найденным по e-mail";
                                self.customer_by_email.state='invalid';
                            }
                            else {
                                self.customer_by_email.description += ", совпадает с заказчиком найденным по e-mail";
                                self.customer_by_email.state='valid';
                            }
                        }
                    }
                    if (self.customer_by_inn) {
                        self.customer_by_inn.fullname = self.customerFullname(self.customer_by_inn);
                        self.customer_by_inn.description = self.customerDescription(self.customer_by_inn);
                    }
                }, this);
            },
            revalidate: function () {
                console.log('revalidate');
                this.thresholdTimeout = null;
                if (this.needLookupCustomer) {
                    this.doLookupCustomer();
                }
            },
            threshold: function (callback) {
                console.log('threshold');
                if (this.thresholdTimeout) {
                    console.log('this.thresholdTimeout' + this.thresholdTimeout);
                    clearTimeout(this.thresholdTimeout);
                }
                this.$validator.validateAll("customerform").then(
                    (result) =>  { this.thresholdTimeout = setTimeout(callback, 1000); console.log('1000'); },
                    (error) =>  { this.thresholdTimeout = setTimeout(callback, 5000); console.log('5000'); },
                )

            }
        },
        computed: {
            showModalLocal: {
                get: function () {
                    return this.show_customer;
                },
                set: function (newValue) {}
            },
            can_fill_customer_name: function() {
                return ((this.customer_by_tel === null) && (this.customer_by_email === null));
            },
            can_create_customer: function() {
                console.log('this.customer_not_found', this.customer_not_found)
                if (!this.customer_not_found) return false;
                console.log('this.veeErrors.items.length', this.veeErrors.items.length)
                if (this.veeErrors.items.length) {
                    console.log(this.veeErrors.items)
                    return false;
                }
                return true;
            },
        },
        created: function() {
            let filled = false;
            if (!this.voucherx.customer_id) {
                if (this.voucherx.contact_name) {
                    var a = this.voucherx.contact_name.split(" ");
                    for (let i=0; i<a.length; i++) {
                        if (!a[i] || a[i]===' ') continie;
                        if (!this.customer_create.surname) {
                            this.customer_create.surname = a[i];
                            filled = true;
                        }
                        else if (!this.customer_create.name) {
                            this.customer_create.name = a[i];
                            filled = true;
                        }
                        else if (!this.customer_create.patro) {
                            this.customer_create.patro = a[i];
                            filled = true;
                        }
                    }
                }
                if (this.voucherx.contact_email) {
                    this.customer_create.email = this.voucherx.contact_email;
                    filled = true;
                }
                if (this.voucherx.org_inn) {
                    this.customer_create.org_inn = this.voucherx.org_inn;
                    filled = true;
                }
                if (this.voucherx.telenums.length) {
                    this.customer_create.tel = this.voucherx.telenums[0].number;
                    filled = true;
                }
            }
            if (filled) {
                this.doLookupCustomer();
            }
        },
        watch: {
        },

    }
</script>
